import { getProfile } from '@/api/auth'
import { adminLogin, getAdminProfile } from '@/api/admin'
import { getToken, setToken, removeToken } from '@/utils/auth'

// 尝试从localStorage获取用户信息和角色
const getUserInfoFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}')
  } catch (e) {
    return {}
  }
}

const getRolesFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem('roles') || '[]')
  } catch (e) {
    return []
  }
}

const state = {
  token: getToken(),
  userInfo: getUserInfoFromStorage(),
  roles: getRolesFromStorage()
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    // 保存到localStorage以防刷新丢失
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
    // 保存到localStorage以防刷新丢失
    localStorage.setItem('roles', JSON.stringify(roles))
  }
}

const actions = {
  // 管理员登录
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      adminLogin({ username: username.trim(), password })
        .then(response => {
          const { token } = response
          commit('SET_TOKEN', token)
          setToken(token)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取管理员信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      // 如果已经有角色信息，直接返回
      if (state.roles && state.roles.length > 0 && Object.keys(state.userInfo).length > 0) {
        resolve(state.roles)
        return
      }

      getAdminProfile()
        .then(response => {
          const { user } = response
          if (!user) {
            reject('验证失败，请重新登录。')
          }

          // 管理员角色
          const roles = ['admin']
          
          commit('SET_ROLES', roles)
          commit('SET_USER_INFO', user)
          resolve(roles)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 登出
  logout({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_USER_INFO', {})
      removeToken()
      // 清除localStorage中的用户信息
      localStorage.removeItem('userInfo')
      localStorage.removeItem('roles')
      resolve()
    })
  },

  // 重置 token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      // 清除localStorage中的用户信息
      localStorage.removeItem('userInfo')
      localStorage.removeItem('roles')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}